import { ParagraphProps } from '../../../components/PageBuilder/Paragraph/Paragraph';
import StemCells from '../../../assets/images/unique/StemCells/stem_cells.jpeg';

export const StemCellsParagraphs: ParagraphProps[] = [
  {
    title: 'What it consists of',
    text: `Stem cells are often discussed because of their role in development, maintenance, and repair. In an educational conversation, the starting point is not hype; it is understanding what the body is trying to repair, what evidence applies, and what factors may be slowing recovery.`,
    img: StemCells,
  },
  {
    title: 'What it may help discuss',
    text: `This topic may be useful when talking about tissue health, recovery, chronic inflammation, mobility, injury history, and the difference between established care and emerging regenerative concepts. It works best as a careful medical discussion, not as a promise of results.`,
  },
  {
    title: 'What is reviewed before deciding',
    text: `A doctor may review diagnosis, imaging or lab information when relevant, previous treatments, medications, chronic conditions, metabolic health, inflammation, expectations, and regulatory context. Patient selection and safety profile are central to any advanced conversation.`,
  },
  {
    title: 'What to keep in mind',
    text: `Sleep, nutrition, movement, stress, inflammation, and chronic disease control can affect recovery and tissue health. Before considering advanced options, it is worth asking what diagnosis is being addressed, what risks exist, what follow-up is required, and whether simpler interventions should come first.`,
  },
];
